import { render, staticRenderFns } from "./pest.vue?vue&type=template&id=5720806a&scoped=true&"
import script from "./pest.vue?vue&type=script&lang=js&"
export * from "./pest.vue?vue&type=script&lang=js&"
import style0 from "./pest.vue?vue&type=style&index=0&id=5720806a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5720806a",
  null
  
)

export default component.exports